import { BoxProps, Text, TextProps } from '@chakra-ui/react'
import { ObjectContentNode } from '@helo/cms'
import { merge } from 'lodash'

import { ConditionalLink } from '../../components/Link/Link'
import { InlineSkeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { valueTransformer } from '../../utils/valueFormatter'
import { pillStyles } from '../utils'
import { ServiceTypeDataType } from './servicetype.types'

const defaultOptions: ServiceTypeDataType['options'] = {}

export const serviceTypeToString = (value: ServiceTypeDataType['value']) => {
  if (!value) return '-'

  return `${value.value}`
}

export const ServiceTypeRenderer = ({
  contentNode,
  isLoading,
  ...props
}: { isLoading?: boolean; contentNode: ObjectContentNode } & BoxProps) => {
  const mergedOptions = merge({}, {}, contentNode.state)
  const { size, linkUrlStorage, linkUrl, _tooltip, textCase, styles } =
    mergedOptions
  const capitalizeStyles: TextProps =
    textCase === 'all'
      ? { textTransform: 'uppercase' }
      : textCase === 'word'
        ? { textTransform: 'capitalize' }
        : {}

  // Extract styles object if it exists and is an object
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  const serviceTypeData = contentNode.data as any
  const serviceTypeValue =
    serviceTypeData?.value ||
    (typeof serviceTypeData === 'string' ? serviceTypeData : null)

  // Build tooltip value - prioritize display value, but allow backend override if it's actually valid
  const defaultTooltipValue =
    serviceTypeData?.providerValue || serviceTypeValue || '-'
  const backendTooltipValue = _tooltip?.asValue
  const finalTooltipValue =
    backendTooltipValue &&
    String(backendTooltipValue).trim() &&
    backendTooltipValue !== '-'
      ? backendTooltipValue
      : defaultTooltipValue

  return (
    <ConditionalTooltip
      tooltipOptions={{
        label: _tooltip?.label || `Service Provider Service Type:`,
        asValue: finalTooltipValue,
      }}
      isDisabled={Boolean(!serviceTypeValue) || isLoading}
    >
      <ConditionalLink to={linkUrl} search={linkUrlStorage}>
        <Text
          size={size}
          {...(linkUrl && pillStyles)}
          {...capitalizeStyles}
          {...props}
          {...customStyles}
        >
          <InlineSkeleton isLoading={isLoading}>
            {valueTransformer(serviceTypeValue)}
          </InlineSkeleton>
        </Text>
      </ConditionalLink>
    </ConditionalTooltip>
  )
}
